import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Entrepreneurs, this is how much confidence you need",
  "description": "",
  "published": "2012-08-16T00:00:00.000Z",
  "redirect_from": ["/blog/entrepreneurs-this-is-how-much-confidence-you-need/swizec/5102"],
  "categories": "Boxing, confidence, History, Muhammad Ali, Sonny Liston, Uncategorized",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`One of the videos from `}<a parentName="p" {...{
        "href": "http://www.louisvuittonjourneys.com/thegreatest/"
      }}>{`Louis Vutton's tribute to Muhammad Ali`}</a>{`.`}</p>
    <p>{`Ali wrote the text before his first fight with `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Sonny_Liston",
        "title": "Sonny Liston"
      }}>{`Liston`}</a>{` - the `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/List_of_heavyweight_boxing_champions",
        "title": "List of heavyweight boxing champions"
      }}>{`heavyweight champion`}</a>{` of the world who won the championship with a first round knockout. That doesn't happen very often.`}</p>
    <p>{`His prediction came true and at 22 Muhammad Ali became the youngest heavyweight championship of the world. And eventually went on to become what many claim to be `}<em parentName="p">{`the greatest fighter who ever lived`}</em>{`.`}</p>
    <p>{`Yes, he trained hard, was naturally gifted and may even have been as pretty as he believes himself to be, but the point is all of that counts for naught if you don't have the confidence in your own abilities. Without confidence, all your talents and training are squandered.`}</p>
    <p>{`To quote a good line about confidence from `}<a parentName="p" {...{
        "href": "http://www.amazon.com/Moneyball-Art-Winning-Unfair-Game/dp/0393057658%3FSubscriptionId%3D0G81C5DAZ03ZR9WH9X82%26tag%3Dageewitahat-20%26linkCode%3Dxm2%26camp%3D2025%26creative%3D165953%26creativeASIN%3D0393057658",
        "title": "Moneyball: The Art of Winning an Unfair Game"
      }}>{`Moneyball`}</a></p>
    <blockquote>
      <p parentName="blockquote">{`There’s not an organization in baseball who would not have taken the chance on this young guy. It didn’t pan out. It happens every year. Some do, some don’t. Two scouts can go into the mind of a young man and determine whether he’s really confident about what he can do. So he gets to sign him based on his ability, but then he’s gotta be successful to be confident. And once he becomes confident that’s when you got something. You make a decision on what you see and things don’t pan out, you move on. That’s baseball. Many are called, few are chosen.`}</p>
    </blockquote>
    <h6 {...{
      "id": "related-articles"
    }}>{`Related articles`}</h6>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://www.thefader.com/2012/06/14/muhammad-ali-is-the-new-face-of-louis-vuitton/"
        }}><img parentName="a" {...{
            "src": "https://i.zemanta.com/94446773_80_80.jpg",
            "alt": null
          }}></img></a><a parentName="li" {...{
          "href": "http://www.thefader.com/2012/06/14/muhammad-ali-is-the-new-face-of-louis-vuitton/"
        }}>{`Muhammad Ali is the New Face of Louis Vuitton`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://www.vanguardngr.com/2012/07/boxer-muhammad-ali-to-be-recognised-for-humanitarian-efforts/"
        }}><img parentName="a" {...{
            "src": "https://i.zemanta.com/noimg_116_80_80.jpg",
            "alt": null
          }}></img></a><a parentName="li" {...{
          "href": "http://www.vanguardngr.com/2012/07/boxer-muhammad-ali-to-be-recognised-for-humanitarian-efforts/"
        }}>{`Boxer Muhammad Ali to be recognised for humanitarian efforts`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://www.inquisitr.com/251724/muhammad-ali-returns-to-philadelphia-for-grandsons-bar-mitzvah/"
        }}><img parentName="a" {...{
            "src": "https://i.zemanta.com/93545089_80_80.jpg",
            "alt": null
          }}></img></a><a parentName="li" {...{
          "href": "http://www.inquisitr.com/251724/muhammad-ali-returns-to-philadelphia-for-grandsons-bar-mitzvah/"
        }}>{`Muhammad Ali Returns to Philadelphia For Grandson's Bar Mitzvah`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://www.democraticunderground.com/1014159545"
        }}><img parentName="a" {...{
            "src": "https://i.zemanta.com/98585840_80_80.jpg",
            "alt": null
          }}></img></a><a parentName="li" {...{
          "href": "http://www.democraticunderground.com/1014159545"
        }}>{`Muhammad Ali named recipient of 2012 Liberty Medal`}</a></li>
    </ul>
    <p><a parentName="p" {...{
        "href": "http://www.zemanta.com/?px",
        "title": "Enhanced by Zemanta"
      }}><img parentName="a" {...{
          "src": "https://img.zemanta.com/zemified_e.png?x-id=ac874e3e-b162-4a90-9cb9-6304bc68676c",
          "alt": "Enhanced by Zemanta"
        }}></img></a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      